import { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  fetchDistrictByProvince,
  fetchProvincesByCountryAction,
  fetchTownshipByDistrict,
} from 'redux/actions/clientsActions'
import { defaultCountryId } from 'Utils/constants'

// Shared province/district/township catalog fetchers, used identically by
// both NewCustomerMap.jsx (create) and Mapa.jsx (edit/add address) so the two
// don't drift out of sync with each other.
export const useAddressCatalogs = () => {
  const dispatch = useDispatch()
  const [provinces, setProvinces] = useState([])
  const [districts, setDistricts] = useState([])
  const [townships, setTownships] = useState([])

  const fetchProvinces = async (countryId = defaultCountryId.countryId) => {
    const Data = await dispatch(fetchProvincesByCountryAction(countryId))
    if (Array.isArray(Data)) setProvinces(Data)
    else console.error('Error getting Provinces: ', Data)
  }

  const fetchDistrict = async pCode => {
    const Data = await dispatch(fetchDistrictByProvince(pCode))
    if (Array.isArray(Data)) setDistricts(Data)
    else console.error('Error getting districts: ', Data)
  }

  const fetchTownship = async dCode => {
    const Data = await dispatch(fetchTownshipByDistrict(dCode))
    if (Array.isArray(Data)) setTownships(Data)
    else console.error('Error getting TownShips: ', Data)
  }

  return {
    provinces,
    districts,
    setDistricts,
    townships,
    setTownships,
    fetchProvinces,
    fetchDistrict,
    fetchTownship,
  }
}
